import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import DefaultButton from '../../../../../../../../../global/default-button/default-button';
import { makeOrganizationMultiSelect } from '../../../../../../../../../global/multi-select/make-organization-multi-select';
import { IMultiSelectClosedPropsDerivedFromItemsList } from '../../../../../../../../../global/multi-select/make-multi-select-in-popover';
import { IAttendeeOrganizationDTO } from '../../../../../../../../../../api/attendees.dao';
import { IAccountContactListItemDTO } from '../../../../../../../../../../api/account-contacts.dao';
import { ISpeakerReferenceDTO } from '../../../../../../../../../../api/event-hubs.dao';
import { getAlreadyAddedItems, getSelectedContacts, toOrganizationItems } from './add-speakers.utils';
import { ADD_TEXT, CANCEL_TEXT } from '../../../../../../../../../../constants/common-labels.constants';
import { ADD_SPEAKERS_BUTTON_TEXT, NEW_SPEAKER_BUTTON_TEXT, NO_MATCHING_SPEAKERS_SEARCH_TEXT, NO_SPEAKERS_TEXT, } from '../../../../../../../../event-hubs.text';
import './add-speakers-popover-button.scss';

interface IAddSpeakersTriggerProps extends IMultiSelectClosedPropsDerivedFromItemsList {
    text: React.ReactNode;
    onClick?: () => void;
}

const AddSpeakersTrigger = React.forwardRef((props: IAddSpeakersTriggerProps, ref: React.Ref<HTMLButtonElement>) => (
    <DefaultButton
        className={classnames('add-line-to-table-btn', 'add-speakers-popover-button__trigger', { 'active': props.isOpen })}
        text={props.text}
        onClick={() => props.isOpen && props.onClick?.()}
        ref={ref}
    />
));

const AddSpeakersMultiSelect = makeOrganizationMultiSelect(AddSpeakersTrigger);

const NewSpeakerActionButton: React.FC<{ onClick: () => void }> = ({ onClick }) => (
    <DefaultButton
        className='add-line-to-table-btn'
        text={<FormattedMessage {...NEW_SPEAKER_BUTTON_TEXT} values={{ prefix: '+ ' }} />}
        onClick={onClick}
    />
);

interface IAddSpeakersPopoverButtonProps {
    contacts: IAccountContactListItemDTO[];
    speakers: ISpeakerReferenceDTO[];
    isLoading: boolean;
    onOpen: () => void;
    resetLoadingState: () => void;
    onAddSpeaker: () => void;
    onAddContacts: (contacts: IAccountContactListItemDTO[]) => void;
}

const AddSpeakersPopoverButton: React.FC<IAddSpeakersPopoverButtonProps> = props => {
    const { contacts, speakers, isLoading, onOpen, resetLoadingState, onAddSpeaker, onAddContacts } = props;

    const handleChange = (selectedOrganizations: IAttendeeOrganizationDTO[]) => {
        onAddContacts(getSelectedContacts(selectedOrganizations, contacts));
    };

    return (
        <AddSpeakersMultiSelect
            items={toOrganizationItems(contacts)}
            value={[]}
            disabled={getAlreadyAddedItems(contacts, speakers)}
            organizationFollowsAttendees={true}
            loadingAttendees={isLoading}
            resetLoadingState={resetLoadingState}
            onClick={onOpen}
            onChange={handleChange}
            text={<FormattedMessage {...ADD_SPEAKERS_BUTTON_TEXT} values={{ prefix: '+ ' }} />}
            applyButtonText={<FormattedMessage {...ADD_TEXT} />}
            resetButtonText={<FormattedMessage {...CANCEL_TEXT} />}
            emptyListText={<FormattedMessage {...NO_SPEAKERS_TEXT} />}
            emptyFilterText={<FormattedMessage {...NO_MATCHING_SPEAKERS_SEARCH_TEXT} />}
            ActionButton={() => <NewSpeakerActionButton onClick={onAddSpeaker} />}
            align='end'
        />
    );
};

export { AddSpeakersPopoverButton };
